<template>
  <onboarding-step center>
    <template #content>
      <div class="text-4xl sm:text-6xl font-serif font-bold text-blue dark:text-white mb-8">
        Nice job! 🎉
      </div>

      <div class="space-y-5 text-xl text-gray-700">
        <p v-if="user.national && user.states.length">
          We gathered a list of
          <span class="font-semibold-text-blue dark:text-white">national schools</span>
          and schools that place graduates in
          <span class="font-semibold text-blue dark:text-white"> {{ user.statesPreferred.map(s => s.name).join(', ') }}</span>.
        </p>
        <p v-else-if="user.national">
          We gathered a list of
          <span class="font-semibold-text-blue dark:text-white">national schools</span>.
        </p>
        <p v-else-if="user.statesPreferred.length">
          We gathered a list of
          schools that place graduates in
          <span class="font-semibold text-blue dark:text-white"> {{ user.statesPreferred.map(s => s.name).join(', ') }}</span>.
        </p>

        <p v-if="user.lsat && user.gpa">
          We also calculated your chances of admission for these schools based on your LSAT of
          <span class="font-semibold text-blue dark:text-white">{{ user.lsat }}</span>
          and GPA of
          <span class="font-semibold text-blue dark:text-white">{{ user.gpa }}</span>.
        </p>
      </div>
    </template>

    <template #cta>
      <div class=" mt-8 lg:mt-10">
        <l-button variant="primary" size="lg" :href="route('report')">
          Continue to report
          <icon name="arrowRightLong"/>
        </l-button>
      </div>
    </template>

    <template #subcontent>
      <img src="/images/illustration-sitting-3.svg" class="h-full w-auto py-16">
    </template>
  </onboarding-step>
</template>

<script setup>
import Icon from "@/components/Icon.vue"
import LButton from "@/components/buttons/LButton.vue"
import OnboardingStep from "@/components/onboardings/OnboardingStep.vue"
import route from "ziggy-js"

const user = defineModel({ type: Object, required: true })
</script>
